module.exports = __webpack_public_path__ + "fonts/fa-v4compatibility.cf7f590.woff2";